const precosStore = {
    state() {
        return {
            precos: '',
            codigo_de_barras: '',
            validade: '',
            categoria: '',
            precosPesaveis: [],
        };
    },
    mutations: {
        setPrecos(state, payload) {
            state.precos = payload;
        },
        setPrecosPesaveis(state, payload) {
            state.precosPesaveis = payload;
        },
        deletePedido(state, payload) {
            const index = state.precos.findIndex(
                (a) =>
                    a.codigo_de_barras == payload.codigo &&
                    a.data_validade == payload.validade &&
                    a.loja == payload.loja,
            );
            if (index !== -1) {
                state.precos.splice(index, 1);
            }
        },
        deletePedidoPesaveis(state, payload) {
            const index = state.precosPesaveis.findIndex(
                (a) =>
                    a.codigo_de_barras == payload.codigo &&
                    a.data_validade == payload.validade &&
                    a.loja == payload.loja,
            );
            if (index !== -1) {
                state.precosPesaveis.splice(index, 1);
            }
        },
    },
    actions: {
        setPrecos(context, payload) {
            context.commit('setPrecos', payload);
        },
        setPrecosPesaveis(context, payload) {
            context.commit('setPrecosPesaveis', payload);
        },
        deletePedido(context, payload) {
            context.commit('deletePedido', payload);
        },
        deletePedidoPesaveis(context, payload) {
            context.commit('deletePedidoPesaveis', payload);
        },
    },
    getters: {
        getPrecos(state) {
            return state.precos;
        },

        getPrecosCategoria(state) {
            let prod = state.precos;

            return prod.reduce(function (key, element) {
                key[element.categoria_2] = key[element.categoria_2] || [];
                key[element.categoria_2].push(element);
                return key;
            }, Object.create(null));
        },

        getPedidos(state) {
            let prod = state.precos;

            let filtrados = prod.filter((element) => {
                return element.status == 'Pendente';
            });

            return filtrados;
        },

        getPedidosPesaveis(state) {
            let prod = state.precosPesaveis;

            let filtrados = prod.filter((element) => {
                return element.status == 'Pendente';
            });

            return filtrados;
        },

        getPedidosHistorico(state) {
            let prod = state.precos;

            let filtrados = prod.filter((element) => {
                return element.status != 'Pendente';
            });

            return filtrados;
        },

        getPedidosCategoria(state) {
            let prod = state.precos;

            let filtrados = prod.filter((element) => {
                return element.status == 'Pendente';
            });

            return filtrados.reduce(function (key, element) {
                key[element.loja] = key[element.loja] || [];
                key[element.loja].push(element);
                return key;
            }, Object.create(null));
        },

        getPedidosCategoriaPesaveis(state) {
            let prod = state.precosPesaveis;

            let filtrados = prod.filter((element) => {
                return element.status == 'Pendente';
            });

            return filtrados.reduce(function (key, element) {
                key[element.loja] = key[element.loja] || [];
                key[element.loja].push(element);
                return key;
            }, Object.create(null));
        },

        getPedidosCategoriaHistorico(state) {
            let prod = state.precos;

            let filtrados = prod.filter((element) => {
                return element.status != 'Pendente' || element.status != 'Vencido sem Aprovação';
            });

            return filtrados.reduce(function (key, element) {
                key[element.loja] = key[element.loja] || [];
                key[element.loja].push(element);
                return key;
            }, Object.create(null));
        },
    },
};

export default precosStore;
